export enum Attendees {
  buyer = 'Buyer',
  teamMember = 'TeamMember'
}

export enum AttendeesToGroup {
  'Buyer' = 'Buyers/Co-Buyers',
  'TeamMember' = 'Contacts'
}

export interface ParsedInvitee {
  type: Attendees;
  value: string;
}
